export const valueParserCommaListFromStrings = (data) => data.join(', ');

export const valueParserObjectFromString = (id) => ({ id });
